var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDepartmentwiseStatistics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 513372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 16.4094L10.1563 13.8218C11.0107 12.7965 11.438 12.2838 12 12.2838C12.562 12.2838 12.9892 12.7965 13.8438 13.8218L14.1562 14.1969C15.0108 15.2222 15.438 15.735 16 15.735C16.562 15.735 16.9893 15.2222 17.8437 14.1969L20 11.6094",
    stroke: "#5B6B79",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26 14C26 19.6568 26 22.4853 24.2426 24.2426C22.4853 26 19.6568 26 14 26C8.34314 26 5.51472 26 3.75736 24.2426C2 22.4853 2 19.6568 2 14C2 8.34314 2 5.51472 3.75736 3.75736C5.51472 2 8.34314 2 14 2C19.6568 2 22.4853 2 24.2426 3.75736C25.4112 4.92585 25.8027 6.56786 25.9339 9.2",
    stroke: "#5B6B79",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1243",
    cx: 25.0714,
    cy: 25.0714,
    r: 6.07143,
    fill: "#404385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.3636 25.2727H22.2727C22.1091 25.2727 22 25.3818 22 25.5455V27.7273C22 27.8909 22.1091 28 22.2727 28H23.3636C23.5273 28 23.6364 27.8909 23.6364 27.7273V25.5455C23.6364 25.3818 23.5273 25.2727 23.3636 25.2727ZM27.7273 24.1818H26.6364C26.4727 24.1818 26.3636 24.2909 26.3636 24.4545V27.7273C26.3636 27.8909 26.4727 28 26.6364 28H27.7273C27.8909 28 28 27.8909 28 27.7273V24.4545C28 24.2909 27.8909 24.1818 27.7273 24.1818ZM25.5455 22H24.4545C24.2909 22 24.1818 22.1091 24.1818 22.2727V27.7273C24.1818 27.8909 24.2909 28 24.4545 28H25.5455C25.7091 28 25.8182 27.8909 25.8182 27.7273V22.2727C25.8182 22.1091 25.7091 22 25.5455 22Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentwiseStatistics);
export default __webpack_public_path__ + "static/media/departmentwise_statistics.f79e922ed5c0efd267b769954663a551.svg";
export { ForwardRef as ReactComponent };